import {
    madnes_add_group,
    madnes_add_img,
    madnes_add_to_group, madnes_get_dimension_wi, madnes_remove_sprite, madnes_set_img_center,
    madnes_set_pos, madnes_set_pos_x, madnes_set_pos_y, madnes_set_visible
} from "../framework/src/engine/madnes/madnes_object";
import {
    madnes_add_bitmap_float, madnes_add_bitmap_text,
    madnes_add_text, madnes_set_bitmap_float, madnes_set_text,
    madnes_set_text_shadow
} from "../framework/src/engine/madnes/madnes_text";
import {bet, madnes_get_currtime, madnes_get_json} from "../framework/src/engine/madnes/madnes";
import {multi, picture_convert, server_config, server_result, wi} from "../framework/src/engine/madnes/madnes_variables";
import {madnes_add_to_render, madnes_rem_from_render} from "../framework/src/engine/madnes/madnes_render";
import {anim_bet_indicators} from "./rof_anims";

var info_pos = 1;

var infotable_count = 4;

var plumX = 456, plumBgX = plumX + 13;
var cherryX = 756, cherryBgX = cherryX + 14;
var lemonX = 1056, lemonBgX = lemonX + 17;
var aX = 456, aBgX = aX + 12;
var nineX = 756, nineBgX = nineX + 15;
var jX = 1056, jBgX = jX + 17;
var devilX = 596, devilBgX = devilX + 9;
var fireX = 596, fireBgX = fireX + 9;

var slides = {
    1: {
        'symbol_Devil': {
            2: { name: '2x_symbol_Devil', 'bgx': devilBgX, 'bgy': 299, 'textx': devilX, 'texty': 292 },
            3: { name: '3x_symbol_Devil', 'bgx': devilBgX, 'bgy': 264, 'textx': devilX, 'texty': 257 },
            4: { name: '4x_symbol_Devil', 'bgx': devilBgX, 'bgy': 287, 'textx': devilX, 'texty': 221 },
            5: { name: '5x_symbol_Devil', 'bgx': devilBgX, 'bgy': 190, 'textx': devilX, 'texty': 183 }
        },
        'symbol_Fire': {
            2: { name: '2x_symbol_Fire', 'bgx': fireBgX, 'bgy': 548, 'textx': fireX, 'texty': 541 },
            3: { name: '3x_symbol_Fire', 'bgx': fireBgX, 'bgy': 513, 'textx': fireX, 'texty': 505 },
            4: { name: '4x_symbol_Fire', 'bgx': fireBgX, 'bgy': 478, 'textx': fireX, 'texty': 470 },
            5: { name: '5x_symbol_Fire', 'bgx': fireBgX, 'bgy': 440, 'textx': fireX, 'texty': 434 }
        }
    },
    2: {
        'symbol_Plum': {
            2: { name: '2x_symbol_Plum', 'bgx': plumBgX, 'bgy': 342, 'textx': plumX, 'texty': 332 },
            3: { name: '3x_symbol_Plum', 'bgx': plumBgX, 'bgy': 290, 'textx': plumX, 'texty': 278 },
            4: { name: '4x_symbol_Plum', 'bgx': plumBgX, 'bgy': 238, 'textx': plumX, 'texty': 227 },
            5: { name: '5x_symbol_Plum', 'bgx': plumBgX, 'bgy': 188, 'textx': plumX, 'texty': 177 }
        },
        'symbol_Cherry': {
            3: { name: '3x_symbol_Cherry', 'bgx': cherryBgX, 'bgy': 289, 'textx': cherryX, 'texty': 278 },
            4: { name: '4x_symbol_Cherry', 'bgx': cherryBgX, 'bgy': 237, 'textx': cherryX, 'texty': 226 },
            5: { name: '5x_symbol_Cherry', 'bgx': cherryBgX, 'bgy': 187, 'textx': cherryX, 'texty': 175 }
        },
        'symbol_Lemon': {
            3: { name: '3x_symbol_Lemon', 'bgx': lemonBgX, 'bgy': 289, 'textx': lemonX, 'texty': 278 },
            4: { name: '4x_symbol_Lemon', 'bgx': lemonBgX, 'bgy': 237, 'textx': lemonX, 'texty': 227 },
            5: { name: '5x_symbol_Lemon', 'bgx': lemonBgX, 'bgy': 187, 'textx': lemonX, 'texty': 175 }
        },
        'symbol_A': {
            3: { name: '3x_symbol_A', 'bgx': aBgX, 'bgy': 536, 'textx': aX, 'texty': 526 },
            4: { name: '4x_symbol_A', 'bgx': aBgX, 'bgy': 484, 'textx': aX, 'texty': 473 },
            5: { name: '5x_symbol_A', 'bgx': aBgX, 'bgy': 434, 'textx': aX, 'texty': 422 }
        },
        'symbol_9': {
            2: { name: '2x_symbol_9', 'bgx': nineBgX, 'bgy': 591, 'textx': nineX, 'texty': 582 },
            3: { name: '3x_symbol_9', 'bgx': nineBgX, 'bgy': 540, 'textx': nineX, 'texty': 530 },
            4: { name: '4x_symbol_9', 'bgx': nineBgX, 'bgy': 489, 'textx': nineX, 'texty': 478 },
            5: { name: '5x_symbol_9', 'bgx': nineBgX, 'bgy': 438, 'textx': nineX, 'texty': 426 }
        },
        'symbol_J': {
            3: { name: '3x_symbol_J', 'bgx': jBgX, 'bgy': 536, 'textx': jX, 'texty': 526 },
            4: { name: '4x_symbol_J', 'bgx': jBgX, 'bgy': 484, 'textx': jX, 'texty': 472 },
            5: { name: '5x_symbol_J', 'bgx': jBgX, 'bgy': 434, 'textx': jX, 'texty': 421 }
        }
    }
};

var slides_wins;

var blinkDuration = 2000;

/*var style = {
	'font': '40px Arial',
	'align': 'right',
	'fontWeight': 'bold',
	'stroke': '#000',
	'strokeThickness': 3,
	'fill': '#FFF',
};

var style2 = {
	'font': '32px Arial',
	'align': 'right',
	'fontWeight': 'bold',
	'stroke': '#000',
	'strokeThickness': 3,
	'fill': '#FFF',
};*/

export function rof_infomenu_init()
{
    for(var i = 1; i <= infotable_count; i++)
    {
        madnes_add_group("settings_group_" + i);
        madnes_set_pos("settings_group_" + i, -9999, -9999);
        madnes_add_img("settings_background_" + i, "settings_background_" + i, 0, 0, 1);
        madnes_add_to_group("settings_group_" + i, "settings_background_" + i);
    }

    for(var slideIndex in slides) {
        var slide = slides[slideIndex];
        for(var sym in slide) {
            for(var i in slide[sym]) {
                var symbTextName = slide[sym][i]['name'];
                var textx = slide[sym][i]['textx'];
                var texty = slide[sym][i]['texty'];
                var bgx = slide[sym][i]['bgx'];
                var bgy = slide[sym][i]['bgy'];

                madnes_add_img(symbTextName + "_bg", 'wintable_frame_' + slideIndex, bgx, bgy, 0.7, 1 , 1);
                madnes_set_visible(symbTextName + "_bg", false);
                madnes_add_to_group("settings_group_" + slideIndex, symbTextName + "_bg");

                var size = 80;

                if(slideIndex == 1) {
                    size = 50;
                }

                madnes_add_bitmap_float(symbTextName, "font_wintable", textx, texty, "", size, 165);
                madnes_set_img_center(symbTextName, 1, 1);
                madnes_add_to_group("settings_group_" + slideIndex, symbTextName);
            }
        }
    }

    for(var i = 1; i <= 2; i++)
    {
        madnes_add_img("settings_background_" + i + "_text", "settings_background_" + i + "_text", 0, 0);
        madnes_add_to_group("settings_group_" + i, "settings_background_" + i + "_text");
    }

    var infotext = madnes_get_json("infotext");

    for(var i in infotext)
    {
        var x = infotext[i]["position"][0];
        var y = infotext[i]["position"][1];

        var page = infotext[i]["page"];
        var lineHeight0 = infotext[i]["title"]["lineHeight"];
        var lineHeight1 = infotext[i]["lineHeight"];

        var styleTitle = {
            "font": "30px Arial",
            "fill": "#fff000",
            "fontWeight": "",
        };
        var styleBody = {
            "font": "30px Arial",
            "fill": "#ffffff",
            "fontWeight": "",
        };

        if(infotext[i]["fontSize"] && infotext[i]["font"]) {
            styleTitle["font"] = infotext[i]["fontSize"] + "px " + infotext[i]["font"];
            styleBody["font"] = infotext[i]["fontSize"] + "px " + infotext[i]["font"];
        }

        setStroke(styleTitle, infotext[i]["title"]);
        setStroke(styleBody, infotext[i]["body"]);

        if(infotext[i]["title"]["align"]) {
            styleTitle["align"] = infotext[i]["title"]["align"];
        }

        if(infotext[i]["title"]["color"]) {
            styleTitle["fill"] = infotext[i]["title"]["color"];
        }

        if(infotext[i]["body"]["color"]) {
            styleBody["fill"] = infotext[i]["body"]["color"];
        }

        if(infotext[i]["title"]["bold"]) {
            styleTitle["fontWeight"] = "bold";
        }

        if(infotext[i]["body"]["bold"]) {
            styleBody["fontWeight"] = "bold";
        }

        var line0 = 0;
        var line1 = 0;

        for(var j in infotext[i]["title"]["content"])
        {
            var text = infotext[i]["title"]["content"][j];
            var textName = "info_header_" + i + "_"  + j + "_" + line0;
            var groupName = "settings_group_" + ( page * 1 );

            madnes_add_text(textName, x, y + line0 * lineHeight0, text, styleTitle);
            madnes_add_to_group(groupName, textName);

            setTextShadow(infotext[i]["title"], textName);
            line0++;
        }

        for(var j in infotext[i]["body"]["content"])
        {
            var text = infotext[i]["body"]["content"][j];
            var textName = "info_body_" + i + "_"  + j + "_" + line1;
            var groupName = "settings_group_" + ( page * 1 );

            madnes_add_text(textName, x, y + line0 * lineHeight0 + line1 * lineHeight1, text, styleBody);
            madnes_add_to_group(groupName, textName);

            setTextShadow(infotext[i]["body"], textName);
            line1++;
        }
    }

    /*madnes_add_graphics("test", plumX, 190);
    madnes_graphics_set_line_style("test", 1, 0xFF0000);
    madnes_graphics_begin_fill("test", 0xFF700B);
    madnes_graphics_draw_rectangle("test", 0, 0, -165, 50);
    madnes_add_to_group("wintable_group_1", "test");*/

    rof_infomenu_update();
}

function setTextShadow(infoText, textName) {
    if(infoText["shadow"]) {
        var shadowOffsetX = infoText["shadow"]["offsetX"] ? infoText["shadow"]["offsetX"] / multi : undefined;
        var shadowOffsetY = infoText["shadow"]["offsetY"] ? infoText["shadow"]["offsetY"] / multi : undefined;
        var shadowColor = infoText["shadow"]["color"] ? infoText["shadow"]["color"] : undefined;
        var shadowBlur = infoText["shadow"]["blur"] ? infoText["shadow"]["blur"] / multi : undefined;

        madnes_set_text_shadow(textName, shadowOffsetX, shadowOffsetY, shadowColor, shadowBlur, null, null);
    }
}

function setStroke(style, infoText) {
    if(infoText["strokeThickness"] && infoText["strokeThickness"] * 1 > 1) {
        style["strokeThickness"] = infoText["strokeThickness"] / multi;
    }

    if(infoText["strokeColor"]) {
        style["strokeColor"] = infoText["strokeColor"];
    }
}

function set_info_sums()
{
    var fsIdx1 = picture_convert.indexOf("symbol_Devil");
    var fsIdx2 = picture_convert.indexOf("symbol_Plum");

    for(var sIndex in slides) {

        var fontSymIndex = fsIdx1;

        if(sIndex == 2) {
            fontSymIndex = fsIdx2;
        }

        var offset = get_bitmap_offset(server_config['logic']['symbols'][fontSymIndex]['factors'][4] * bet, 165);
        var slide = slides[sIndex];

        for(var sym in slide) {
            var symIndex = picture_convert.indexOf(sym);
            var factors = server_config['logic']['symbols'][symIndex]['factors'];

            for(var facIndex in factors) {
                if(factors[facIndex] == 0) {
                    continue;
                }

                var textIndex = facIndex * 1 + 1;
                var symbTextName = slide[sym][textIndex]['name'];
                var val = bet * factors[facIndex];

                var y = slide[sym][textIndex]['texty'];

                madnes_set_bitmap_float(symbTextName, val, offset > 0 ? 1 : 165);
                madnes_set_pos_y(symbTextName, y + offset * -1);
            }
        }
    }
}

export var openinfo = false;

var settings_background_pos = 0;
export function rof_infomenu_open()
{
    playWinFramesAnim(1);

    settings_background_pos = 1;

    for(var i = 1; i <= infotable_count; i++)
    {
        madnes_set_pos("settings_group_" + i, 2500, 0);
        madnes_set_visible("settings_group_" + i, true);
    }

    madnes_set_pos("settings_group_1", 0, 0);

    openinfo = true;
}

export function rof_infomenu_close()
{
    for(var i = 1; i <= infotable_count; i++)
    {
        madnes_set_pos("settings_group_" + i, -9999, -9999);
        madnes_set_visible("settings_group_" + i, false);
    }

    openinfo = false;
}

function infomenu_click()
{
    rof_infomenu_update();
}

export function rof_infomenu_update()
{
    setTimeout(function() {
        anim_bet_indicators();
        set_info_sums();
    }, 100);

}

var infomenu_move_in = 0;
var infomenu_move_dir = 0;

var move_start = 0;
var move_total = 250;

export function rof_infomenu_left()
{
    if(!openinfo) return;
    if(infomenu_move_in == 0)
    {
        stopWinFramesAnim();

        move_start = madnes_get_currtime();
        infomenu_move_in = 1;
        infomenu_move_dir = 1;
        madnes_add_to_render(infomenu_move);
    }
}

export function rof_infomenu_right()
{
    if(!openinfo) return;
    if(infomenu_move_in == 0)
    {
        stopWinFramesAnim();

        move_start = madnes_get_currtime();
        infomenu_move_in = 1;
        infomenu_move_dir = -1;
        madnes_add_to_render(infomenu_move);
    }
}

var settings_background_pos2 = 0;
function infomenu_move()
{
    var difftime = madnes_get_currtime() - move_start;
    var end = 0;
    if(difftime > move_total)
    {
        difftime = move_total;
        end = 1;
    }

    settings_background_pos2 = settings_background_pos * 1 + ( infomenu_move_dir * -1 );
    if(settings_background_pos2 > infotable_count)
    {
        settings_background_pos2 = 1;
    }
    if(settings_background_pos2 < 1)
    {
        settings_background_pos2 = infotable_count;
    }

    var pos1 = wi * ( ( ( 100 / move_total ) * difftime ) / 100 ) * infomenu_move_dir;
    var pos2 = 0;
    if(infomenu_move_dir < 0)
    {
        pos2 = pos1 + wi;
    }
    else
    {
        pos2 = wi * -1 + pos1;
    }

    madnes_set_pos_x("settings_group_" + settings_background_pos, pos1);
    madnes_set_pos_x("settings_group_" + settings_background_pos2, pos2);

    if(end == 1)
    {
        playWinFramesAnim(settings_background_pos2);

        madnes_rem_from_render(infomenu_move);

        madnes_set_pos_x("settings_group_" + settings_background_pos2, 0);
        madnes_set_pos_x("settings_group_" + settings_background_pos, 2500);

        settings_background_pos = settings_background_pos2;
        infomenu_move_in = 0;
        infomenu_move_dir = 0;
    }
}

var blinkTimer, blinkTimer2, winFramesTimer;

function setWinFrameVisible(lineWin, visible)
{
    var symbol = transformSymbolName(picture_convert[lineWin['symbol']]);
    var count = lineWin['position'].length;
    var frameName = count + "x_" + symbol + "_bg";

    madnes_set_visible(frameName, visible);
}

function initSlidesWins() {

    slides_wins = {};
    slides_wins[1] = new Array();
    slides_wins[2] = new Array();

    if(!server_result || !server_result.result || typeof server_result.result.lineWins == 'undefined') {
        return;
    }

    for(var lwIdx in server_result.result.lineWins) {
        var symbol = picture_convert[server_result['result']['lineWins'][lwIdx]['symbol']];

        if(symbol == 'symbol_Devil' || symbol == 'symbol_Fire') {
            slides_wins[2].push(server_result.result.lineWins[lwIdx]);
        } else {
            slides_wins[1].push(server_result.result.lineWins[lwIdx]);
        }
    }
}

function playWinFramesAnim(infopos)
{
    initSlidesWins();
    stopWinFramesAnim();

    if(server_result != null && typeof server_result.result.lineWins != 'undefined') {
        if(infopos == 1 || infopos == 2) { //page 1
            animateWinFrames(slides_wins[infopos], 0);
        }
    }
}

function animateWinFrames(wins, i)
{
    if(wins.length < 1) {
        return false;
    }

    if(i > wins.length - 1) {
        i = 0;
    }

    var lineWin = wins[i];

    setWinFrameVisible(lineWin, true);

    blinkTimer = setTimeout(function() {
        setWinFrameVisible(lineWin, false);
        blinkTimer2 = setTimeout(animateWinFrames.bind(this, wins, ++i), blinkDuration / 2);
    }, blinkDuration / 2);
}

function stopWinFramesAnim()
{
    if(typeof blinkTimer != 'undefined') {
        clearTimeout(blinkTimer);
    }

    if(typeof blinkTimer2 != 'undefined') {
        clearTimeout(blinkTimer2);
    }

    for(var sIndex in slides) {
        var slide = slides[sIndex];
        for(var sym in slide) {
            for(var tIdx in slide[sym]) {
                madnes_set_visible(slide[sym][tIdx]['name'] + "_bg", false);
            }
        }
    }
}

function transformSymbolName(name) {
    switch(name) {
        case 'symbol_Orange':
            return 'symbol_Lemon';
        case 'symbol_Melon':
            return 'symbol_Plum';
        case 'symbol_Q':
        case 'symbol_10':
            return 'symbol_J';
        case 'symbol_K':
            return 'symbol_A';
        default:
            return name;
    }
}

function get_bitmap_offset(text, max_width)
{
    var offs = 0;

    madnes_add_bitmap_text("infotext_tmp", "font_wintable", 0, 0, text, 80);
    madnes_set_text("infotext_tmp", text);

    if(madnes_get_dimension_wi("infotext_tmp") > max_width) {
        offs = 1;
    }

    madnes_remove_sprite("infotext_tmp");

    return offs;
}